<template>
  <div
    class="modal fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">Edit Addresses</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <h3>Physical Address</h3>
          <div class="mb-3">
            <label class="control-label">Line 1</label>
            <input v-model="editingClient.address_line_1" type="text" class="form-control" />
          </div>
          <div class="mb-3">
            <label class="control-label">Line 2</label>
            <input v-model="editingClient.address_line_2" type="text" class="form-control" />
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">City / Town</label>
              <input v-model="editingClient.city" type="text" class="form-control" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Postcode</label>
              <input v-model="editingClient.postcode" type="text" class="form-control" />
            </div>
          </div>
          <div class="mb-3">
            <label class="control-label">Country</label>
            <input v-model="editingClient.country" type="text" class="form-control" />
          </div>

          <h3 class="mt-4">Postal Address</h3>
          <div class="form-check mb-3">
            <input v-model="postalMatch" id="checkbox-same-address" type="checkbox" class="form-check-input" />
            <label class="form-check-label" for="checkbox-same-address">Same as physical address</label>
          </div>
          <div class="mb-3">
            <label class="control-label">Line 1</label>
            <input v-model="editingClient.postal_address_line_1" type="text" class="form-control" />
          </div>
          <div class="mb-3">
            <label class="control-label">Line 2</label>
            <input v-model="editingClient.postal_address_line_2" type="text" class="form-control" />
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">City / Town</label>
              <input v-model="editingClient.postal_city" type="text" class="form-control" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Postcode</label>
              <input v-model="editingClient.postal_postcode" type="text" class="form-control" />
            </div>
          </div>
          <div class="mb-3">
            <label class="control-label">Country</label>
            <input v-model="editingClient.postal_country" type="text" class="form-control" />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="handleSave" class="btn btn-rounded btn-primary">Save</c-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, pick } from 'lodash'
import { CModal } from '@chameleon/chameleon-vue'
import { helperMethods } from 'vx/modules/clients'

const ADDRESS_FIELDS = ['address_line_1', 'address_line_2', 'city', 'postcode', 'country']

export default {
  extends: CModal,

  props: ['client'],

  data () {
    return {
      editingClient: {}
    }
  },

  mounted () {
    this.addEventListener('open', () => {
      this.editingClient = cloneDeep(this.client)
    })
  },

  computed: {
    postalMatch: {
      get () {
        return ADDRESS_FIELDS.every(field => this.editingClient[field] === this.editingClient[`postal_${field}`])
      },

      set (value) {
        ADDRESS_FIELDS.forEach((field) => {
          this.$set(this.editingClient, `postal_${field}`, value ? this.editingClient[field] : null)
        })
      }
    }
  },

  methods: {
    ...helperMethods,

    handleSave () {
      const payload = pick(this.editingClient, [
        ...ADDRESS_FIELDS,
        ...ADDRESS_FIELDS.map(field => `postal_${field}`)
      ])

      return this.updateClient({ id: this.client.id, payload }).then(() => {
        this.close()
      })
    }
  }
}
</script>
